import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'

Vue.use(Router)

export default new Router({
  mode: 'history',//History
  // mode:'hash',//Hash
  routes: [
    {
      path: '/',
      name: 'Login',
      component:Login,
      meta: { timestamp: true }
    },
    {
      path: '/Table',
      name: 'Table',
      component:() => import('@/components/Table')
    },
    {
      path: '/Map',
      name: 'Map',
      component:() => import('@/components/Map')
    },
    {
      path:'/Setting',
      name: 'Setting',
      component:() => import('@/components/Setting')
    },
    {
      path:'/ChangePW',
      name: 'ChangePW',
      component:() => import('@/components/ChangePW')
    },
    {
      path:'/Menu',
      name: 'Menu',
      component:() => import('@/components/Menu'),
      children:[
        {
          path: '/Menu/Dashboard',
          name: 'Dashboard',
          component:() => import('@/dashboard/MainPage'),
        },
        {
          path: '/Menu/History',
          name: 'History',
          component:() => import('@/components/History'),
        },
        {
          path: '/Menu/Report',
          name: 'Report',
          component:() => import('@/Report/Report'),
          children:[
            {
              path: '/Menu/Report/PositionLogDetail',
              name: 'PositionLogDetail',
              component:() => import('@/Report/PositionLogDetail'),
            },
            {
              path: '/Menu/Report/TripDetail',
              name: 'TripDetail',
              component:() => import('@/Report/TripDetail')
            },
            {
              path: '/Menu/Report/PairedEventDetail',
              name: 'CombolEventDetail',
              component:() => import('@/Report/CombolEventDetail')
            },
            {
              path: '/Menu/Report/AlertEventDetail',
              name: 'AlertEventDetail',
              component:() => import('@/Report/AlertEventDetail')
            },
            {
              path: '/Menu/Report/TripSummary',
              name: 'TripSummary',
              component:() => import('@/Report/TripSummary')
            },
            {
              path: '/Menu/Report/MileageDaySummary',
              name: 'MileageDaySummary',
              component:() => import('@/Report/MileageDaySummary')
            },
            {
              path: '/Menu/Report/MileageMonthSummary',
              name: 'MileageMonthSummary',
              component:() => import('@/Report/MileageMonthSummary')
            },
            {
              path: '/Menu/Report/FuelEstimationMonthSummary',
              name: 'FuelEstimationMonthSummary',
              component:() => import('@/Report/FuelEstimationMonthSummary')
            },
            {
              path: '/Menu/Report/EventSummary',
              name: 'EventSummary',
              component:() => import('@/Report/EventSummary')
            },
            {
              path: '/Menu/Report/VehicleAliveReport',
              name: 'VehicleAliveReport',
              component:() => import('@/Report/VehicleAliveReport')
            },
            {
              path: '/Menu/Report/ShippingDailyReport',
              name: 'ShippingDailyReport',
              component:() => import('@/Report/ShippingDailyReport')
            },
            {
              path: '/Menu/Report/AutoEmail',
              name: 'AutoEmail',
              component:() => import('@/Report/AutoEmail')
            },
            {
              path: '/Menu/Report/BackupFilesDownload',
              name: 'BackupFilesDownload',
              component:() => import('@/Report/BackupFilesDownload')
            },
            {
              path: '/Menu/Report/DaysOfUseMonthSummary',
              name: 'DaysOfUseMonthSummary',
              component:() => import('@/Report/DaysOfUseMonthSummary')
            },
            {
              path: '/Menu/Report/LoginHistoryDetail',
              name: 'LoginHistoryDetail',
              component:() => import('@/Report/LoginHistoryDetail')
            },
            {
              path: '/Menu/Report/WorkTimeDaySummary',
              name: 'WorkTimeDaySummary',
              component:() => import('@/Report/WorkTimeDaySummary')
            },
            {
              path: '/Menu/Report/WorkTimeMonthSummary',
              name: 'WorkTimeMonthSummary',
              component:() => import('@/Report/WorkTimeMonthSummary')
            },
            {
              path: '/Menu/Report/ColdChainTemperatureReport',
              name: 'ColdChainTemperatureReport',
              component:() => import('@/Report/ColdChainTemperatureReport')
            },
            //加報表步驟 6 加入Router
            {
              path: '/Menu/Report/CANGODetail',
              name: 'CANGODetail',
              component:() => import('@/Report/CANGODetail')
            },
          ]
        },
        {
          path: '/Menu/Tracking',
          name: 'Vehicle',
          component:() => import('@/components/Vehicle')
        },
        {
          path: '/Menu/Video',
          name: 'Video',
          component:() => import('@/components/Video')
        },
        {
          path: '/Menu/Manage',
          name: 'Manage',
          component:() => import('@/Manage/Manage'),
          children:[
            {
              path: '/Menu/Manage/BasicDataManage',
              name: 'BasicDataManage',
              component:() => import('@/Manage/BasicDataManage'),
            },
            {
              path: '/Menu/Manage/UDIDManage',
              name: 'UDIDManage',
              component:() => import('@/Manage/UDIDManage'),
            },
            {
              path: '/Menu/Manage/MaintenanceList',
              name: 'MaintanceList',
              component:() => import('@/Manage/MaintanceList'),
            },
            {
              path: '/Menu/Manage/MaintenanceReport',
              name: 'MaintanceReport',
              component:() => import('@/Manage/MaintanceReport'),
            },
            {
              path: '/Menu/Manage/ManageFleet',
              name: 'ManageGroup',
              component:() => import('@/Manage/ManageGroup'),
            },
            {
              path: '/Menu/Manage/ManageAccount',
              name: 'ManageAccount',
              component:() => import('@/Manage/ManageAccount'),
            },
            {
              path: '/Menu/Manage/ManageDriver',
              name: 'ManageDriver',
              component:() => import('@/Manage/ManageDriver'),
            },
            {
              path: '/Menu/Manage/ManageLineBinding',
              name: 'ManageLineBinding',
              component:() => import('@/Manage/ManageLineBinding'),
            },
            {
              path: '/Menu/Manage/ManageVehicle',
              name: 'ManageVehicle',
              component:() => import('@/Manage/ManageVehicle'),
            },
            {
              path: '/Menu/Manage/ManageVehicle_New',
              name: 'ManageVehicle_New',
              component:() => import('@/Manage/ManageVehicle_New'),
            },
            {
              path: '/Menu/Manage/ManagePOI',
              name: 'ManagePOI',
              component:() => import('@/Manage/ManagePOI'),
            },
            {
              path: '/Menu/Manage/ManageGeofence',
              name: 'ManageGeofence',
              component:() => import('@/Manage/ManageGeofence'),
            },
            {
              path: '/Menu/Manage/ManageGeofenceAssign',
              name: 'ManageGeofenceAssign',
              component:() => import('@/Manage/ManageGeofenceAssign'),
            },
            {
              path: '/Menu/Manage/ManageFleetATCommand',
              name: 'ManageFleetATCommand',
              component:() => import('@/Manage/ManageFleetATCommand'),
            },
            {
              path: '/Menu/Manage/BatchCommand',
              name: 'BatchCommand',
              component:() => import('@/Manage/BatchCommand'),
            },
            {
              path: '/Menu/Manage/FunctionAuthoritySetting',
              name: 'FunctionAuthoritySetting',
              component:() => import('@/Manage/FunctionAuthoritySetting'),
            },
            {
              path: '/Menu/Manage/MaintenanceSchedule',
              name: 'MaintenanceSchedule',
              component:() => import('@/Manage/MaintenanceSchedule'),
            },
            {
              path: '/Menu/Manage/FleetEventSetup',
              name: 'FleetEventSetup',
              component:() => import('@/Manage/FleetEventSetup'),
            },
            //加管理步驟 6 加入Router
            {
              path: '/Menu/Manage/ManageLineBindingGroup',
              name: 'ManageLineBindingGroup',
              component:()=> import('@/Manage/ManageLineBindingGroup')
            }
          ]
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js